<template>
  <div class="gjw-bimface-viewer">
    <div
      ref="viewer"
      class="viewer cover"
    />
    <div
      v-if="status === 'error'"
      class="no-token cover flex-container flex-row flex-horiz-center flex-verti-center"
    >
      {{ $t('3d.notSupported') }}
    </div>
    <div
      v-if="status === 'loading'"
      class="loading cover flex-container flex-row flex-horiz-center flex-verti-center"
    >
      <span>
        {{ $t('3d.loadingModel') }}
      </span>
    </div>
  </div>
</template>

<script>export default {
  props: {
    familyType: {
      type: String,
      default: ''
    },
    viewToken: {
      type: String,
      default: null
    },
    refresh: {
      type: Number,
      default: 1
    }
  },

  data() {
    return {
      app: null,
      familyTypes: null,
      status: 'error',
      loaded: false
    }
  },

  watch: {
    async familyType(newValue) {
      if (this.app) {
        try {
          const viewer = this.app.getViewer()
          await viewer.showFamilyTypeByName(newValue)
        } catch (error) {
          this.$console.error(error)
        }
      }
    },

    refresh() {
      this.reload()
    },

    viewToken(newValue, oldValue) {
      this.reload()
    }
  },

  mounted() {
    this.initializeBimface()
  },

  methods: {
    addBimfaceSdk() {
      if (!window.BimfaceSDKLoaderConfig) {
        const script = document.createElement('script')
        script.src = process.env.VUE_APP_BIMFACE_LOADER_SDK
        script.charset = 'utf-8'
        document.body.appendChild(script)
        const script1 = document.createElement('script')
        script1.src = process.env.VUE_APP_BIMFACE_HOST_CONFIG_JS
        script1.charset = 'utf-8'
        document.body.appendChild(script1)
      }
    },
    async initializeBimface() {
      if (this.loaded) {
        return
      }
      this.addBimfaceSdk()
      this.status = 'loading'
      if (this.viewToken) {
        try {
          const bimfaceLoaderConfig = new window.BimfaceSDKLoaderConfig()
          bimfaceLoaderConfig.viewToken = this.viewToken
          window.BimfaceSDKLoader.load(
            bimfaceLoaderConfig,
            (viewMetaData) => {
              this.loaded = true
              window.Glodon.Bimface.Viewer.Viewer3D.prototype.getFamilyTypesAsync = function() {
                return new Promise((resolve, reject) => {
                  this.getFamilyTypes((data) => {
                    resolve(data)
                  })
                })
              }
              window.Glodon.Bimface.Viewer.Viewer3D.prototype.showFamilyTypeByName = async function(name) {
                let types = await this.getFamilyTypesAsync()
                if (!types) {
                  const resourceHost = this._opt.resourceHost
                  const databagId = this._data.databagId
                  const familytypes = await fetch(`${resourceHost}/${databagId}/metadata/familyInfo.json`).then((response) => response.json())
                  if (familytypes) {
                    types = familytypes.types
                  }
                }
                if (types) {
                  const type = types.find((t) => t.name === name)
                  if (type) {
                    this.showFamilyTypeById(type.id)
                  }
                }
              }
              let ConfigClass = null
              let AppClass = null
              if (viewMetaData.viewType === '3DView') {
                ConfigClass = window.Glodon.Bimface.Application.WebApplication3DConfig
                AppClass = window.Glodon.Bimface.Application.WebApplication3D
              } else if (viewMetaData.viewType === 'rfaView') {
                ConfigClass = window.Glodon.Bimface.Application.WebApplicationRfaConfig
                AppClass = window.Glodon.Bimface.Application.WebApplicationRfa
              }

              if (AppClass && ConfigClass) {
                this.status = 'success'
                const config = new ConfigClass()
                config.domElement = this.$refs.viewer
                config.Buttons = []
                config.enableViewHouse = false
                config.enableOrbit = true
                this.app = new AppClass(config)
                window.CLOUD.GlobalData.UseBatchRendering = true

                const appEvents = window.Glodon.Bimface.Application.WebApplicationRfaEvent
                this.app.addView(this.viewToken)
                this.app.addEventListener(appEvents.ViewAdded, () => {
                  const combo = document.querySelector('.bf-combobox.bf-family')
                  if (combo) {
                    combo.parentElement.style.display = 'none'
                  }
                  this.app.getViewer().setView(window.Glodon.Bimface.Viewer.ViewOption.Home)
                  this.app.getViewer().startAutoRotate(0.5)
                  this.app.getViewer().showFamilyTypeByName(this.familyType)
                  this.app.render()
                })
                this.app.addEventListener(appEvents.Error, (data) => {
                  this.loaded = false
                  this.status = 'error'
                })
              } else {
                this.status = 'error'
              }
            },
            // eslint-disable-next-line handle-callback-err
            (error) => {
              this.loaded = false
              this.status = 'error'
            }
          )
        } catch (e) {
          this.loaded = false
          this.status = 'error'
          // this.$console.error(e)
        }
      } else {
        this.loaded = false
        this.status = 'error'
      }
    },

    reload() {
      this.loaded = false
      this.$nextTick(() => {
        const view = this.$refs.viewer
        const children = view.childNodes
        for (let i = children.length - 1; i >= 0; i--) {
          view.removeChild(children[i])
        }
        this.initializeBimface()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.gjw-bimface-viewer {
  width: 100%;
  height: 100%;
  position: relative;
  .cover {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    text-align: center;
    line-height: 100%;
  }
}
</style>
